import React from 'react';
import { Shield } from 'lucide-react';

// Per-bag insurance Yes/No + declared value, for the agent/partner edit screen.
export const BagInsuranceField = ({ bag, idx, onChange }) => {
  const dv = Math.min(parseFloat(bag.declared_value) || 0, 10000);
  return (
    <div className="sm:col-span-2 border-t border-dashed border-gray-300 pt-2" data-testid={`edit-auth-insurance-${idx}`}>
      <label className="text-[10px] font-mono uppercase text-gray-500 flex items-center gap-1">
        <Shield size={11} className="text-[#00C853]" />Insurance — ask the customer
      </label>
      <div className="grid grid-cols-2 gap-2 mt-1">
        <button type="button" data-testid={`edit-auth-insurance-yes-${idx}`}
          onClick={() => onChange(idx, 'insurance_opted', true)}
          className={`px-2 py-1.5 border-2 border-black text-[11px] font-mono uppercase font-bold ${bag.insurance_opted ? 'bg-[#00C853]' : 'bg-white hover:bg-[#E8FFF0]'}`}>
          Yes, insure
        </button>
        <button type="button" data-testid={`edit-auth-insurance-no-${idx}`}
          onClick={() => { onChange(idx, 'insurance_opted', false); onChange(idx, 'declared_value', 0); }}
          className={`px-2 py-1.5 border-2 border-black text-[11px] font-mono uppercase font-bold ${!bag.insurance_opted ? 'bg-gray-900 text-white' : 'bg-white hover:bg-gray-100'}`}>
          No insurance
        </button>
      </div>
      {bag.insurance_opted && (
        <div className="mt-2">
          <input type="number" min="1" max="10000" step="1" data-testid={`edit-auth-declared-${idx}`}
            value={bag.declared_value || ''} placeholder="Declared value ₹ (max 10,000)"
            onChange={(e) => onChange(idx, 'declared_value', e.target.value)}
            className="w-full border-2 border-black px-2 py-1 text-sm font-mono" />
          {(parseFloat(bag.declared_value) || 0) > 10000 ? (
            <p className="text-[10px] font-mono mt-1 text-red-700 font-bold" data-testid={`edit-auth-declared-error-${idx}`}>Maximum cover is ₹10,000 — please enter a lower value.</p>
          ) : (
            <p className="text-[10px] font-mono mt-1">Premium (4%): <b className="text-[#00A844]">+ ₹{(dv * 0.04).toFixed(2)}</b> — added to the amount due.</p>
          )}
        </div>
      )}
    </div>
  );
};
